// Member codes look like WCW-7K3Q9P2X: the store prefix and 8 characters from an
// alphabet without look-alikes (no 0/O or 1/I).
export const MEMBER_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
export const MEMBER_CODE_RE = /^[A-Z0-9]{1,6}-[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{8}$/;

/** Reads a scanned or typed member code: trims, uppercases, and accepts it with or without the dash. */
export function cleanMemberCode(raw: string): string | null {
  const s = raw.trim().toUpperCase().replace(/\s+/g, '');
  const withDash = /^[A-Z0-9]{1,6}[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{8}$/.test(s) && !s.includes('-') ? `${s.slice(0, -8)}-${s.slice(-8)}` : s;
  // Phone numbers are all digits; codes always have the letters of the store prefix.
  return MEMBER_CODE_RE.test(withDash) && /[A-Z]/.test(withDash.split('-')[0]) ? withDash : null;
}
